import { createFileRoute } from '@tanstack/react-router'

import { MatchmakingPage } from '@/features/matchmaking'

export const Route = createFileRoute('/_event/conexoes')({
  component: MatchmakingRoute
})

function MatchmakingRoute() {
  return <MatchmakingPage />
}
